import dayjs from 'dayjs';

export const formatDateToString = (date: string) => {
  // TODO: add handler for different days
  return dayjs(date).format('HH:mm A');
};
